export default __webpack_public_path__ + "static/media/Indara.d0398241.png";